import {get,postJson,post} from '@/api/request/CommonRequest'
import axios from 'axios'
import { Message, Modal } from 'view-design'
import qs from 'qs'

export let loginMethod = {}

loginMethod.test = function () {
  return get('/user/test2')
}

loginMethod.login = function (params) {
  return post('/user/login',params)
}

loginMethod.loginV2 = function (params) {
  return post('/user/login_v2',params)
}

